import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const styles = {
  footer: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '20px 10px',
    textAlign: 'center',
    display: 'flex',
    flexWrap: 'wrap', // Allows wrapping on smaller screens
    justifyContent: 'space-around',
    gap: '20px', // Space between sections
  },
  footerSection: {
    flex: '1 1 200px', // Grow, shrink, and set min width for responsiveness
    padding: '10px',
    minWidth: '150px', // Ensure a minimum width for small screens
  },
  heading: {
    color: '#fcbf29',
    marginBottom: '15px',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  listItem: {
    margin: '5px 0',
  },
  link: {
    color: '#fff',
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
  },
  logo: {
    width: '100px',
    height: 'auto',
  },
  socialIcons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px', // Space between social icons
  },
  socialIcon: {
    width: '30px',
    height: '30px',
  },
  hover: {
    textDecoration: 'underline',
  },
  // Media query for small screens
  '@media (max-width: 600px)': {
    footer: {
      flexDirection: 'column', // Stack sections vertically on small screens
      textAlign: 'center',
    },
    footerSection: {
      padding: '10px 0',
    },
  },
};

// Footer component
const Footer = () => {
  useEffect(() => {
    const t = "https://app.agentbo.co.bw";
    const a = { bot_key: "9f08fcfcf10f44d8", welcome_msg: true, branding_key: "agentbo", server: "https://app.agentbo.co.bw", e: "p" };
    
    const c = document.head || document.getElementsByTagName("head")[0];
    const n = document.createElement("script");
    n.async = true;
    n.defer = true;
    n.type = "text/javascript";
    n.src = t + "/static/js/widget.js?config=" + JSON.stringify(a);
    c.appendChild(n);
  }, []);

  return (
    <footer style={styles.footer}>
      {/* Product Section */}
      <div style={styles.footerSection}>
        <h3 style={styles.heading}>[ A PRODUCT OF ]</h3>

        <Link to="/" style={styles.link}> <img
          src="./images/stencil-logos-02-1-1-qbdoob825580i3dn0j01wtnopb4anxu4xzkjc6l0bg (1).png" // replace with the actual logo path
          alt="Stencil Logo"
          style={styles.logo}

        /></Link>
      </div>

      {/* Important Links Section */}
      <div style={styles.footerSection}>
        <h3 style={styles.heading}>[ Important Links ]</h3>
        <ul style={styles.list}>
          <li style={styles.listItem}><Link to="/about" style={styles.link}>About Us</Link></li>
          <li style={styles.listItem}><Link to="Privacy-policy" style={styles.link}>Privacy Policy</Link></li>
          <li style={styles.listItem}><Link to="Terms-and-conditions" style={styles.link}>Terms and Conditions</Link></li>
        </ul>
      </div>

      {/* Contact Section */}
      <div style={styles.footerSection}>
        <h3 style={styles.heading}>[ Contact Us ]</h3>
        <ul style={styles.list}>
          <li style={styles.listItem}>+267 3165 466</li>
          <li style={styles.listItem}><a href="mailto:info@agentbo.co.bw" style={styles.link}>info@agentbo.co.bw</a></li>
        </ul>
      </div>

      {/* Social Media Section */}
      <div style={styles.footerSection}>
        <h3 style={styles.heading}>[ Social Media ]</h3>
        <div style={styles.socialIcons}>
          <a href="https://x.com/AgentBo"><img src="/images/twitter2.png" alt="Twitter" style={styles.socialIcon} /></a>
          <a href="https://www.instagram.com/agentbo_/?igshid=NjIwNzIyMDk2Mg%3D%3D"><img src="/images/instagram.png" alt="Instagram" style={styles.socialIcon} /></a>
          <a href="https://www.linkedin.com/showcase/agentbo/about/?viewAsMember=true"><img src="/images/linkedin.png" alt="LinkedIn" style={styles.socialIcon} /></a>
          <a href="https://www.facebook.com/profile.php?id=61551063395482"><img src="./images/facebook.png" alt="Facebook" style={styles.socialIcon} /></a>
        </div>
      </div>
    </footer>

  );
};

export default Footer;
